<template>
    <q-layout view="hHR LpR lFr">
        <img src="../assets/material-bg.jpg" width="100%" height="100%" style="position:absolute">

        <q-footer bordered class="bg-white">
            <install-notification/>
        </q-footer>
        <q-page-container>
            <div class="row justify-between">
                <q-btn no-caps class="q-mr-xs q-pa-sm" flat to="/help-and-support" icon="my:support-primary"
                       color="primary" :label="$t('helps.menu.index')"/>
                <language-selector />
                <q-space/>
                <span style="padding: 4px 16px; display: inline-flex; align-items: center; font-size:10px; z-index: 1"
                      class="text-grey">Version {{ version }}
                </span>
            </div>

            <transition name="slide" mode="out-in">
                <router-view />
            </transition>
        </q-page-container>
    </q-layout>
</template>

<script>
import InstallNotification from "./partials/InstallNotification"
import LanguageSelector from "src/components/LanguageSelector"
export default {
    name: "AuthLayout",
    props: {},
    computed: {},
    data() {
        return {}
    },
    methods: {
        clearCookies() {
            const listOfCookies = ['user', 'version', 'system_token', 'google_form_viewed', 'lang', 'ip_country']
            listOfCookies.forEach(item => {
                this.$q.cookies.remove(item, {path: '/'})
            })
        },
    },
    created() {
        this.clearCookies()
        this.$q.cookies.set('version', this.version)
    },
    mounted() {},
    components: {InstallNotification, LanguageSelector},
}
</script>
<style>
.background-image {
    background-image: url('../assets/material-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    height: 100vh;
}
</style>
